export default {

	init() {
		console.log('accordion init...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	bindEvents() {
		$('.accordion-list').each(function() {
			$(this).find('[data-accordion]').on('click', function (e) {
				Accordion.toggleVisibility(this);
			});
		});
	},

	toggleVisibility(elem) {
		let $toggle = $(elem);
		let $target = $('#' + $toggle.attr('aria-controls'));
		let $group = $toggle.parents('[data-accordion-group]');
		let isGroup = $group.length;

		if (!$target.length) {
			return;
		}

		if (isGroup) {
			let $toggles = $group.find('[data-accordion]').not($toggle);
			let $panes = $group.find('.accordion-pane').not($target);

			$toggles.attr('aria-expanded', 'false')
			$panes.removeClass('is-active').attr('hidden', true);
		}

		if ($target[0].hasAttribute('hidden')) {
            $target.removeAttr('hidden').addClass('is-active');
            $toggle.attr('aria-expanded', 'true');
        } else {
            $target.removeClass('is-active').attr('hidden', true);
            $toggle.attr('aria-expanded', 'false');
        }
	}

}